import React, { useEffect } from "react";
import { LabeledTextInput } from '../components/labeledInput';
import { CheckboxComponent } from '../components/checkbox';
import { DateInput } from '../components/dateInput';
import { EmailInput } from '../components/emailInput';
import { NumberInput } from '../components/numberInput';
import { ChoiceRadioButton } from '../components/yes-no-radiobutton';
import { FileInput } from '../components/fileInput';
import { SelectInput } from '../components/selectInput';

export function SubGridChecker({
    questionAnswer,
    register,
    errors,
    pdfInputChange,
    pdfInputClick,
    pdfAddToRef,
    fieldIndex,
    valueOfRel,
    userVote,
    setUserVote,
    watch,
    condition,
    form,
    checkOnPreciseValue
}) {

    //
    // ?? Recupero i valori RHF dei due campi collegati
    //
    const voto100 = watch?.("voto_diploma_100");
    const voto60 = watch?.("voto_diploma_60");

    //
    // ?? Verifico se sono compilati (>=1, non zero)
    //
    const hasVoto100 = Number(voto100) > 0;
    const hasVoto60 = Number(voto60) > 0;

    //
    // ?? Logica di mutua esclusione
    //
    const disable100 = hasVoto60;  // Se compilo /60 ? disabilito /100
    const disable60 = hasVoto100;  // Se compilo /100 ? disabilito /60


    //
    // ?? Reset automatico dei campi disabilitati
    //
    useEffect(() => {
        if (disable100) {
            form?.setValue("voto_diploma_100", "");
        }
    }, [disable100]);

    useEffect(() => {
        if (disable60) {
            form?.setValue("voto_diploma_60", "");
        }
    }, [disable60]);

    return (
        <div className="col-span-4">
            <div>
                {questionAnswer?.related
                    .filter(rel => {
                        if (checkOnPreciseValue) {
                            return rel.eq === valueOfRel;
                        } else {
                            return true;
                        }
                    })
                    .map((questionRel, relIndex) => (

                        <div key={relIndex}>
                            <div
                                className={`${questionRel.title || questionRel.subtitle ? "pt-6" : ""} ${!valueOfRel ? "text-disabled-color" : ""
                                    }`}
                            >
                                {questionRel?.title && (
                                    <div className="font-bold">{questionRel?.title}</div>
                                )}

                                {questionRel?.subtitle && (
                                    <div>{questionRel?.subtitle}</div>
                                )}
                            </div>

                            <div
                                className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-x-4 text-sm w-100px-mobile"
                                style={{ alignItems: "flex-end" }}
                            >

                                {questionRel.fields.map((questionFieldRel, fieldIndexRel) => {

                                    //
                                    // ?? TEXT
                                    //
                                    if (questionFieldRel.type === "text") {
                                        return (
                                            <div key={fieldIndexRel}>
                                                <LabeledTextInput
                                                    key={questionFieldRel.slug}
                                                    labelText={questionFieldRel.label}
                                                    placeholderText={questionFieldRel.label}
                                                    name={questionFieldRel.slug}
                                                    register={register}
                                                    isRequired={questionFieldRel.required}
                                                    minLength={questionFieldRel.minlength}
                                                    maxLength={questionFieldRel.maxlength}
                                                    errors={errors}
                                                    errorMsg="Campo obbligatorio"
                                                    value={questionFieldRel.value}
                                                    valueOfRel={valueOfRel}
                                                    setUserVoteFalse={() => setUserVote(false)}
                                                    setUserVoteTrue={() => setUserVote(true)}
                                                    form={form}
                                                />
                                            </div>
                                        );
                                    }

                                    //
                                    // ?? CHECKBOX
                                    //
                                    if (questionFieldRel.type === "checkbox") {
                                        return (
                                            <div key={fieldIndexRel}>
                                                <CheckboxComponent
                                                    key={questionFieldRel.slug}
                                                    name={questionFieldRel.slug}
                                                    labelText={questionFieldRel.label}
                                                    register={register}
                                                    isRequired={questionFieldRel.required}
                                                    errors={errors}
                                                    errorMsg="Campo obbligatorio"
                                                    index={fieldIndex}
                                                    valueOfRel={valueOfRel}
                                                />
                                            </div>
                                        );
                                    }

                                    //
                                    // ?? DATE
                                    //
                                    if (questionFieldRel.type === "date") {
                                        return (
                                            <div key={fieldIndexRel}>
                                                <DateInput
                                                    key={questionFieldRel.slug}
                                                    name={questionFieldRel.slug}
                                                    labelText={questionFieldRel.label}
                                                    placeholderText={questionFieldRel.label}
                                                    register={register}
                                                    isRequired={questionFieldRel.required}
                                                    errors={errors}
                                                    valueOfRel={valueOfRel}
                                                    errorMsg="Campo obbligatorio"
                                                />
                                            </div>
                                        );
                                    }

                                    //
                                    // ?? EMAIL
                                    //
                                    if (questionFieldRel.type === "email") {
                                        return (
                                            <div key={fieldIndexRel}>
                                                <EmailInput
                                                    key={questionFieldRel.slug}
                                                    name={questionFieldRel.slug}
                                                    labelText={questionFieldRel.label}
                                                    placeholderText={questionFieldRel.label}
                                                    register={register}
                                                    isRequired={questionFieldRel.required}
                                                    errors={errors}
                                                    errorMsg="Campo obbligatorio"
                                                    minLength={questionFieldRel.minlength}
                                                    maxLength={questionFieldRel.maxlength}
                                                    valueOfRel={valueOfRel}
                                                />
                                            </div>
                                        );
                                    }



                                    //
                                    // ?? NUMBER
                                    //
                                    if (questionFieldRel.type === "number") {

                                        // Range personalizzati (solo validazione RHF)
                                        let minOverride = questionFieldRel.min;
                                        let maxOverride = questionFieldRel.max;

                                        if (questionFieldRel.slug === "voto_diploma_60") {
                                            minOverride = 48;
                                            maxOverride = 60;
                                        }

                                        if (questionFieldRel.slug === "voto_diploma_100") {
                                            minOverride = 80;
                                            maxOverride = 100;
                                        }

                                        return (
                                            <div key={fieldIndexRel}>
                                                <NumberInput
                                                    key={questionFieldRel.slug}
                                                    name={questionFieldRel.slug}
                                                    labelText={questionFieldRel.label}
                                                    placeholderText={questionFieldRel.label}
                                                    register={register}
                                                    min={minOverride}
                                                    max={maxOverride}
                                                    isRequired={questionFieldRel.required}
                                                    errors={errors}
                                                    errorMsg="Campo obbligatorio"
                                                    valueOfRel={
                                                        questionFieldRel.slug === "voto_diploma_100"
                                                            ? !disable100
                                                            : questionFieldRel.slug === "voto_diploma_60"
                                                                ? !disable60
                                                                : valueOfRel
                                                    }
                                                />

                                                {/* Messaggio informativo del range */}
                                                {questionFieldRel.slug === "voto_diploma_60" && (
                                                    <div className="mt-1 text-[11px] text-disabled-color">
                                                        Valori ammessi: 48 - 60
                                                    </div>
                                                )}

                                                {questionFieldRel.slug === "voto_diploma_100" && (
                                                    <div className="mt-1 text-[11px] text-disabled-color">
                                                        Valori ammessi: 80 - 100
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }


                                    //
                                    // ?? RADIO
                                    //
                                    if (questionFieldRel.type === "radio") {
                                        return (
                                            <div key={fieldIndexRel}>
                                                <ChoiceRadioButton
                                                    key={questionFieldRel.slug}
                                                    name={questionFieldRel.slug}
                                                    labelText={questionFieldRel.label}
                                                    placeholderText={questionFieldRel.label}
                                                    register={register}
                                                    isRequired={questionFieldRel.required}
                                                    errors={errors}
                                                    errorMsg="Campo obbligatorio"
                                                    valueOfRel={valueOfRel}
                                                />
                                            </div>
                                        );
                                    }

                                    //
                                    // ?? FILE
                                    //
                                    if (questionFieldRel.type === "file") {
                                        return (
                                            <>
                                                <div
                                                    key={fieldIndexRel}
                                                    className="md:col-span-3 lg:col-span-3"
                                                    style={{ display: "contents" }}
                                                >
                                                    <FileInput
                                                        key={questionFieldRel.slug}
                                                        name={questionFieldRel.slug}
                                                        labelText={questionFieldRel.label}
                                                        placeholderText={questionFieldRel.labelText}
                                                        inputRef={(el) => pdfAddToRef(el)}
                                                        isRequired={questionFieldRel.required}
                                                        errors={errors}
                                                        errorMsg="Campo obbligatorio"
                                                        onClick={() => pdfInputClick(fieldIndexRel, questionFieldRel.id)}
                                                        onChange={(e) =>
                                                            pdfInputChange(
                                                                e,
                                                                fieldIndexRel,
                                                                questionFieldRel.id,
                                                                questionAnswer?.related?.id
                                                            )
                                                        }
                                                        index={fieldIndex}
                                                        id={questionFieldRel.id}
                                                        valueOfRel={valueOfRel}
                                                        isInSubGrid={true}
                                                    />
                                                </div>
                                            </>
                                        );
                                    }

                                    //
                                    // ?? SELECT
                                    //
                                    if (questionFieldRel.type === "select") {
                                        return (
                                            <div key={fieldIndexRel}>
                                                <SelectInput
                                                    key={questionFieldRel.slug}
                                                    name={questionFieldRel.slug}
                                                    labelText={questionFieldRel.label}
                                                    placeholderText={questionFieldRel.label}
                                                    options={questionFieldRel.options}
                                                    register={register}
                                                    isRequired={questionFieldRel.required}
                                                    errors={errors}
                                                    errorMsg="Campo obbligatorio"
                                                    valueOfRel={valueOfRel}
                                                />
                                            </div>
                                        );
                                    }

                                    return null;
                                })}
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
}
